export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7825.d8df4222.jpg";